import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/landingContent";
type CtaButtonProps = {
  label: string;
  subtext?: string;
  id?: string;
  className?: string;
};
export function CtaButton({
  label,
  subtext,
  id,
  className = ""
}: CtaButtonProps) {
  return <div id={id} className={`mx-auto w-full max-w-xl text-center ${className}`} data-id="element-36" data-mp="ckj6ng7zw7l6">
      <a href={CHECKOUT_URL} className="group animate-cta-pulse flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-[17px] font-extrabold uppercase leading-tight tracking-wide text-white transition-[background-color,transform] duration-150 ease-out hover:bg-cta-dark active:scale-[0.98] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:text-lg" data-id="element-37" data-mp="qkahj837t7uy">
        <span className="text-balance" data-id="element-38" data-mp="19c38yy2myl0k">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-39" data-mp="198p4nkaew1qh" />
      </a>
      {subtext && <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-40" data-mp="35z8sifjhfdf4">{subtext}</p>}
    </div>;
}